import React from 'react';
import { CedarTreeIcon } from './icons/CedarTreeIcon';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-emerald-950 text-emerald-50 relative overflow-hidden" data-id="element-103">
      {/* Lebanese Flag Stripe at Top of Footer */}
      <div className="h-[4px] w-full flex absolute top-0 left-0 z-20" data-id="element-104">
        <div className="h-full w-1/3 bg-[#ED1C24]" data-id="element-105"></div>
        <div className="h-full w-1/3 bg-white" data-id="element-106"></div>
        <div className="h-full w-1/3 bg-[#006233]" data-id="element-107"></div>
      </div>

      {/* Large subtle watermark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.04] pointer-events-none" data-id="element-108">
        <CedarTreeIcon className="w-[600px] h-[600px] text-white" data-id="element-109" />
      </div>

      <div className="container mx-auto px-4 pt-24 pb-12 relative z-10" data-id="element-110">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16" data-id="element-111">
          {/* Brand Column */}
          <div className="lg:col-span-5 pr-8" data-id="element-112">
            <div className="flex items-center gap-4 mb-8" data-id="element-113">
              <div className="p-2 bg-white/10 rounded-full backdrop-blur-sm" data-id="element-114">
                <CedarTreeIcon className="w-10 h-10 text-white" data-id="element-115" />
              </div>
              <span className="font-serif font-bold text-2xl leading-tight tracking-wide" data-id="element-116">
                Consulate General
                <br data-id="element-117" />
                of Lebanon
              </span>
            </div>
            <p className="text-emerald-100/80 text-lg leading-relaxed mb-8 max-w-md" data-id="element-118">
              Serving the Lebanese community in New South Wales, Australia with
              dedication, professionalism, and pride.
            </p>
            <div className="flex gap-4" data-id="element-119">
              {/* Social placeholders if needed in future */}
              <div className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/20 transition-colors cursor-pointer" data-id="element-120"></div>
              <div className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/20 transition-colors cursor-pointer" data-id="element-121"></div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2" data-id="element-122">
            <h4 className="font-bold text-white mb-8 uppercase tracking-widest text-sm border-b border-white/10 pb-4 inline-block" data-id="element-123">
              Quick Links
            </h4>
            <ul className="space-y-4 text-emerald-100/80 text-base" data-id="element-124">
              <li data-id="element-125">
                <a href="#home" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-126">
                  Home
                </a>
              </li>
              <li data-id="element-127">
                <a href="#announcements" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-128">
                  Announcements
                </a>
              </li>
              <li data-id="element-129">
                <a href="#about" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-130">
                  About the Consulate
                </a>
              </li>
              <li data-id="element-131">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-132">
                  Consular Fees
                </a>
              </li>
              <li data-id="element-133">
                <a href="#about" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-134">
                  Public Holidays
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-2" data-id="element-135">
            <h4 className="font-bold text-white mb-8 uppercase tracking-widest text-sm border-b border-white/10 pb-4 inline-block" data-id="element-136">
              Services
            </h4>
            <ul className="space-y-4 text-emerald-100/80 text-base" data-id="element-137">
              <li data-id="element-138">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-139">
                  Passports
                </a>
              </li>
              <li data-id="element-140">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-141">
                  Visas
                </a>
              </li>
              <li data-id="element-142">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-143">
                  Civil Status
                </a>
              </li>
              <li data-id="element-144">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-145">
                  Legalization
                </a>
              </li>
              <li data-id="element-146">
                <a href="#services" className="hover:text-white hover:translate-x-1 inline-block transition-all" data-id="element-147">
                  Power of Attorney
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3" data-id="element-148">
            <h4 className="font-bold text-white mb-8 uppercase tracking-widest text-sm border-b border-white/10 pb-4 inline-block" data-id="element-149">
              Contact Us
            </h4>
            <ul className="space-y-4 text-emerald-100/80 text-base" data-id="element-150">
              <li className="leading-relaxed" data-id="element-151">
                Level 13, 155 Castlereagh St
                <br data-id="element-152" />
                SYDNEY NSW 2000
              </li>
              <li className="pt-4" data-id="element-153">
                <a href="tel:+61292337474" className="hover:text-white font-medium transition-colors flex items-center gap-2" data-id="element-154">
                  +61 2 9233 7474
                </a>
              </li>
              <li data-id="element-155">
                <a href="mailto:info@lebconsyd.org.au" className="hover:text-white font-medium transition-colors flex items-center gap-2" data-id="element-156">
                  info@lebconsyd.org.au
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-157">
          <p className="text-emerald-100/60 text-sm text-center md:text-left" data-id="element-158">
            &copy; {currentYear > 2026 ? currentYear : 2026} Consulate General
            of Lebanon - Sydney. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-emerald-100/60" data-id="element-159">
            <a href="#" className="hover:text-white transition-colors" data-id="element-160">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-161">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-162">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}